import React, { useState } from 'react';
import '../common/css/pwChange.css';

function PWChange() {
    const onClickPWChange = () => {
        window.location.href = '/login';
    };

    return (
        <div className='content'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>회원가입</div>

                    <div>비밀번호 변경</div>
                </div>
            </div>
            <div id='bodyContainer'>
                <div class='member_wrap'>
                    <div class='member_right' id='idSearchBox'>
                        <div class='page_hgroup'>
                            <h3 class='title'>비밀번호 변경</h3>
                        </div>
                        <table class='write_table for-mo__idsearch'>
                            <colgroup>
                                <col style={{ width: '190px' }} />
                                <col style={{ width: '600px' }} />
                            </colgroup>
                            <tbody>
                                <tr class='name_box'>
                                    <th>비밀번호</th>
                                    <td className='firstPwChangeInput'>
                                        <div class='boxed'>
                                            <input
                                                type='text'
                                                id='usrPw'
                                                name='usrPw'
                                                maxlength='60'
                                            />
                                        </div>
                                        <span class='authNumberTxt'>
                                            *6~12자 영문, 숫자, 특수문자 조합
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>비밀번호 확인</th>
                                    <td>
                                        <div class='boxed'>
                                            <input
                                                type='text'
                                                id='usrPwCheck'
                                                name='usrPwCheck'
                                                maxlength='60'
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class='btn_wrap'>
                            <div class='fl_c'>
                                <input
                                    type='button'
                                    value='비밀번호 변경'
                                    class='btn46 red'
                                    onClick={onClickPWChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PWChange;
